// extracted by mini-css-extract-plugin
export var avatarBone = "_5-4";
export var buttonBone = "_5-3";
export var continueBone = "_5-a";
export var frame = "_5-1";
export var logoBone = "_5-2";
export var pickerGrid = "_5-d";
export var pitchBone = "_5-9";
export var productBone = "_5-8";
export var sectionBone = "_5-7";
export var shell = "_5-0";
export var skeletonPulse = "_5-b";
export var subtitleBone = "_5-6";
export var titleBone = "_5-5";
export var viewport = "_5-c";